/**
 * 위시리스트 stale 데이터 자동 정리 + 드로어 안내
 *
 * Swym 백엔드에 저장된 상품 중 storefront fetch 실패(404 — 삭제·archived·draft 등)
 * 한 아이템들을 페이지 로드 시 자동 일괄 제거. 정리 결과는 위시리스트 드로어를
 * 처음 열 때 1회 안내 배너로 노출.
 *
 * 데이터 소스:
 *   - localStorage['swym-products'] — Swym 이 캐시한 아이템 목록 (동기 읽기)
 *     예: { "all": [ { lid, empi, epi, du, dt, bt, ... }, ... ] }
 *
 * 사용 API:
 *   - window.SwymCallbacks.push(fn)              — Swym 준비되면 fn(swat) 호출
 *   - window._swat.api.removeFromWishList(opts, success, error)
 *
 * 가드:
 *   - 세션당 1회만 실행 (sessionStorage)
 *   - validate 가 명확히 404 인 것만 제거 — network error 는 stale 로 오판 X (보수적)
 *   - 모든 호출 typeof + try/catch — Swym API 변경 시 silent fallback
 *   - 50% 이상 stale 검출 시 콘솔에 경고만 출력 (의도된 데이터 정리 신호이므로 진행)
 */
(function () {
  'use strict';

  const KEY_RAN = 'wishlist-stale-cleanup-ran';
  const KEY_REMOVED = 'wishlist-stale-cleanup-removed';
  const KEY_DISMISSED = 'wishlist-stale-cleanup-dismissed';
  const NOTICE_ID = 'wishlist-stale-notice';
  const DRAWER_SELECTOR = '#swym-storefront-layout, swym-storefront-layout-as-drawer';

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    if (!sessionStorage.getItem(KEY_RAN)) {
      setTimeout(runCleanup, 1500);
    }
    observeDrawer();
  });

  async function runCleanup() {
    try {
      sessionStorage.setItem(KEY_RAN, '1');

      const items = readStoredItems();
      if (!items.length) return;

      const validations = await Promise.all(
        items.map(async (it) => ({
          item: it,
          valid: await validateProduct(extractHandle(it.du)),
        }))
      );
      const stale = validations.filter((v) => !v.valid).map((v) => v.item);

      if (!stale.length) {
        console.info('[wishlist-stale-cleanup] no stale items (' + items.length + ' total)');
        return;
      }

      const results = await Promise.all(stale.map(removeItem));
      const removed = results.filter(Boolean).length;
      console.info(
        '[wishlist-stale-cleanup] removed ' + removed + ' / ' + stale.length + ' stale items (of ' + items.length + ' total)'
      );

      if (removed > 0) {
        sessionStorage.setItem(KEY_REMOVED, String(removed));
        try {
          window.SwymStorefrontLayoutExtensions?.refreshWishList?.();
        } catch (e) {}
      }
    } catch (e) {
      console.warn('[wishlist-stale-cleanup] cleanup failed:', e);
    }
  }

  function readStoredItems() {
    try {
      const raw = localStorage.getItem('swym-products');
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed?.all) ? parsed.all : [];
    } catch (e) {
      return [];
    }
  }

  function extractHandle(du) {
    if (!du || typeof du !== 'string') return null;
    const m = du.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  async function validateProduct(handle) {
    if (!handle) return true;
    try {
      const res = await fetch(MISTO.localeUrl(`/products/${encodeURIComponent(handle)}.js`), { method: 'HEAD' });
      return res.status !== 404;
    } catch (e) {
      return true;
    }
  }

  function removeItem(item) {
    return new Promise((resolve) => {
      const api = window._swat && window._swat.api;
      if (!api || typeof api.removeFromWishList !== 'function') {
        resolve(false);
        return;
      }
      try {
        api.removeFromWishList(
          { lid: item.lid, empi: item.empi, epi: item.epi, du: item.du },
          () => resolve(true),
          () => resolve(false)
        );
      } catch (e) {
        resolve(false);
      }
    });
  }

  function observeDrawer() {
    const observer = new MutationObserver(() => {
      const drawer = document.querySelector(DRAWER_SELECTOR);
      if (drawer && !drawer.dataset.staleNoticeBound) {
        drawer.dataset.staleNoticeBound = '1';
        observer.disconnect();
        setTimeout(() => maybeShowNotice(drawer), 600);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function maybeShowNotice(drawer) {
    const removed = parseInt(sessionStorage.getItem(KEY_REMOVED) || '0', 10);
    if (!removed) return;
    if (sessionStorage.getItem(KEY_DISMISSED)) return;
    if (drawer.querySelector('#' + NOTICE_ID)) return;

    const notice = document.createElement('div');
    notice.id = NOTICE_ID;
    notice.className = 'wishlist-stale-notice';
    notice.innerHTML =
      '<span class="wishlist-stale-notice__text">더 이상 판매되지 않는 ' +
      removed +
      '개 상품이 정리되었습니다.</span>' +
      '<button type="button" class="wishlist-stale-notice__btn" aria-label="안내 닫기">확인</button>';

    const target =
      drawer.querySelector('.swym-storefront-layout-layout') ||
      drawer.querySelector('#swym-storefront-layout-container') ||
      drawer;
    if (target.firstElementChild) {
      target.insertBefore(notice, target.firstElementChild);
    } else {
      target.appendChild(notice);
    }

    notice.querySelector('.wishlist-stale-notice__btn').addEventListener('click', () => {
      sessionStorage.setItem(KEY_DISMISSED, '1');
      notice.remove();
    });
  }
})();
